/**
 * Product splash Add to cart: load the live shop SKU and stamp a cart line.
 * Reuses customerPricingContract (same path as Product Detail).
 */

import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../services/firebase';
import { normalizePricingKey, productsCollectionName } from '../services/pricingTierService';

export { buildSplashAddToCartLine, SPLASH_ADD_FAIL_COPY } from './productSplashCopy';

export async function loadShopProductRowForSplash(sku, pricingKey) {
    const code = String(sku || '').trim();
    const key = normalizePricingKey(pricingKey);
    if (!code || !key) return null;

    const collName = productsCollectionName(key);
    try {
        const direct = await getDoc(doc(db, collName, code));
        if (direct.exists()) {
            const data = direct.data() || {};
            return { Code: data.Code || code, ...data };
        }
        const qSnap = await getDocs(
            query(collection(db, collName), where('Code', '==', code), limit(1))
        );
        if (qSnap.empty) return null;
        const data = qSnap.docs[0].data() || {};
        return { Code: data.Code || code, ...data };
    } catch (error) {
        console.warn('[productSplashCart] loadShopProductRowForSplash failed', error);
        return null;
    }
}
